import { render, staticRenderFns } from "./my-info.vue?vue&type=template&id=d6211cfc&scoped=true&"
import script from "./my-info.vue?vue&type=script&lang=js&"
export * from "./my-info.vue?vue&type=script&lang=js&"
import style0 from "./my-info.vue?vue&type=style&index=0&id=d6211cfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6211cfc",
  null
  
)

export default component.exports